import { unionBounds } from '@/utils/bounds-kit';
import type { Bounds } from '@/version-types';
import type { ReadyTextRenderHighlight } from '../../assets';
import type { TextRenderHighlight } from '../../types';
import type { RenderContext } from '../context';
import { buildHighlightFragments } from './fragments';
import { renderHighlight } from './render';

export type HighlightVisual = { bounds: Bounds | null; draw: (target: SVGElement) => void };

/**
 * 构建当前输入所有 ready Highlight 的同步渲染状态。
 *
 * @param context - 当前一轮不变的输入、snapshot 与命名空间。
 * @param getHighlight - 只读取 Highlight 素材的具名 getter。
 * @returns 存在可渲染 Highlight 时返回节点和视觉边界。
 */
export const resolveHighlightVisual = (
    context: RenderContext,
    getHighlight?: (request: TextRenderHighlight) => ReadyTextRenderHighlight | undefined,
): HighlightVisual | undefined => {
    if (!getHighlight) return undefined;
    const { input, snapshot } = context;
    let bounds: Bounds | null = null;
    const nodes = buildHighlightFragments(input, snapshot).flatMap((fragment) => {
        const ready = getHighlight(fragment.highlight);
        if (!ready) return [];
        const rendered = renderHighlight(fragment, ready);
        if (!rendered) return [];
        bounds = unionBounds(bounds, rendered.bounds);
        return [rendered.node];
    });
    return bounds
        ? {
              bounds,
              draw: (target) => nodes.forEach((node) => target.appendChild(node)),
          }
        : undefined;
};
